import React, { useEffect, useState, useRef } from 'react'
import { withTranslation } from 'react-i18next'
import { TileSettingsComponent } from 'srcReact/components'
import Tile from 'srcReact/components/common2/Tile'
import Icon from 'srcReact/components/icons/Icon'

import styles from './styles.module.scss'

const TileWithSettingsComponent = (props) => {
  const { isMobile, t, className, text, subtext, color, defaultOption } = props

  const [show, setShow] = useState(false)
  const tileRef = useRef()

  useEffect(() => {
    if (isMobile) {
      document.addEventListener('touchstart', handleClick)
    } else {
      document.addEventListener('mousedown', handleClick)
    }

    return () => {
      if (isMobile) {
        document.removeEventListener('touchstart', handleClick)
      } else {
        document.removeEventListener('mousedown', handleClick)
      }
    }
  }, [])

  const handleClick = (e) => {
    e.preventDefault()
    if (tileRef.current !== null && e.target == tileRef.current) {
      openSettings()
    } else {
      if (!e.target.href || e.target.href == null) {
        hideSettings()
      } else {
        window.location = e.target.href
      }
    }
  }

  const openSettings = () => {
    setShow(true)
  }

  const hideSettings = () => {
    setShow(false)
  }

  return (
    <React.Fragment>
      {show == false ? (
        <Tile defaultOption={defaultOption} color={color} className={styles.tileComponent}>
          <button ref={tileRef} className={styles.threeDotsButton} onClick={openSettings}>
            <Icon name='three_dots24' size='large32' styleModifier={styles.threeDotsIcon} />
          </button>
          <span className={styles.text}>{text}</span>
          {subtext && subtext != '' && <span className={styles.subText}>{subtext}</span>}
        </Tile>
      ) : (
        <TileSettingsComponent className={styles.tileSettings} {...props} />
      )}
    </React.Fragment>
  )
}

const ExtendedComponent = withTranslation('common')(TileWithSettingsComponent)
export { ExtendedComponent as TileWithSettingsComponent }
